// extracted by mini-css-extract-plugin
var _1 = "I44wpHhr";
var _2 = "I44wpHhr";
export { _1 as "link-to-map", _2 as "linkToMap" }
